// @ts-nocheck
/* eslint-disable */
export const llaPlatformFormCheckIcon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.5 16.5V5.5C30.5 3.29086 28.7091 1.5 26.5 1.5H5.5C3.29086 1.5 1.5 3.29086 1.5 5.5V26.5C1.5 28.7091 3.29086 30.5 5.5 30.5H14.5M9.5 9.5H22.5M9.5 17.5H22.5M21.5 27.5L24.5 30.5C26 26 30.5 23.5 30.5 23.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'form-check' as const
};